/**
 * Created by pajicv on 10/4/18.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import ProjectCycles from './ProjectCycles';
import { spinnerWhileLoading } from '../../utils/components';

const enhance = compose(
    connect(
        (state, props) => {
            const { cycleId, projectTitle, index, history } = props;
            return ({
                cycle: populate(state.firebase, `cycles/${cycleId}`, []),
                auth: state.firebase.auth,
                projectTitle,
                cycleId,
                index,
                history
            });
        }
    ),
    firebaseConnect((props) => {
        const { cycleId } = props;
        return [{ path: `cycles/${cycleId}` }];
    }),
    spinnerWhileLoading(['cycle'])
);

export default enhance(ProjectCycles);



// WEBPACK FOOTER //
// ./src/components/Cycles/ProjectCycles.enhancer.js